import { render, staticRenderFns } from "./ElementRadio.vue?vue&type=template&id=4a0e4599&scoped=true"
import script from "./ElementRadio.vue?vue&type=script&lang=js"
export * from "./ElementRadio.vue?vue&type=script&lang=js"
import style0 from "./ElementRadio.vue?vue&type=style&index=0&id=4a0e4599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e4599",
  null
  
)

export default component.exports